module.exports = __webpack_public_path__ + "static/media/google.48fdfd3e.svg";